export default "__VITE_ASSET__JvsKas0m__"